import { useEffect } from 'react';

const SpinnerLoader = (props) => {
    useEffect(() => {
        props.setShow(false);
        setTimeout(() => props.setShow(true), 1000);
    }, []);
}

export default SpinnerLoader;